import { useEffect, useState } from "react";
import GameCanvas from "./ui/GameCanvas";
import AuthGate from "./ui/AuthGate";
import { currentAccount, logout, onAuthChange, type Account } from "@/net/auth";

/**
 * App root + auth gate. Login is required to play: no session → AuthGate; session →
 * the game (which loads that account's cloud save). `undefined` = still checking.
 */
export default function App() {
  const [account, setAccount] = useState<Account | null | undefined>(undefined);

  useEffect(() => {
    let mounted = true;
    currentAccount().then((a) => {
      if (mounted) setAccount(a);
    });
    // Keep the same object when only the token refreshed (same id) so we don't churn.
    const unsub = onAuthChange((a) => {
      if (mounted) setAccount((prev) => (prev && a && prev.id === a.id ? prev : a));
    });
    return () => {
      mounted = false;
      unsub();
    };
  }, []);

  const handleLogout = async (): Promise<void> => {
    await logout();
    setAccount(null);
  };

  if (account === undefined) {
    return <div className="app-boot">Loading…</div>;
  }
  if (!account) {
    return <AuthGate onAuthed={setAccount} />;
  }
  return <GameCanvas account={account} onLogout={handleLogout} />;
}
